export default __webpack_public_path__ + "static/burger-taco-friends-dbe5239b8dc29b493e11b009b5c42f92.svg";